import React, { FC } from 'react';
import { Button } from '@components/UIKit/Button/Button';
import { Toy } from '@specs/views';
import { useTranslation } from '@hooks/useTranslation';
import { useRouter } from 'next/router';
import { LinksEnum } from '@specs/navigation';
interface Props {
  slug: Toy.Single['slug'];
}
export const GoToToyButton: FC<Props> = ({
  slug
}) => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const goToToyHandler = async () => {
    await router.push({
      pathname: LinksEnum.TOY,
      query: {
        slug
      }
    });
  };
  return <Button id='go_to_toy_button' color={'White'} size={'medium'} onClick={goToToyHandler} icons={{
    left: {
      name: 'toys'
    }
  }} data-sentry-element="Button" data-sentry-component="GoToToyButton" data-sentry-source-file="GoToToyButton.tsx">
            {tr({
      id: 'btn.to.figure'
    })}
        </Button>;
};